import {
    LoadedEvent,
    RapidStorEvent,
} from '@r6digital/rapidstor-types/types/Events/Event';
import {
    MoveInEvent,
    MoveInPayload,
} from '@r6digital/rapidstor-types/types/Events/MoveIn';
import {
    ReservationEvent,
    ReservationEventPayloadStandard,
    ReservationViaMoveInEvent,
    ReservationWithFeeEvent,
    SaveQuoteEvent,
} from '@r6digital/rapidstor-types/types/Events/Reservation';
import {
    ScrollAction,
    ScrollEvent,
} from '@r6digital/rapidstor-types/types/Events/Scroll';
import {
    ShowPricesEvent,
    ShowPricesPayload,
} from '@r6digital/rapidstor-types/types/Events/ShowPrices';

import Logger from '@/core/utils/logging';

export const dispatchEvent = (event: RapidStorEvent) => {
    // Event-based listener
    document.dispatchEvent(
        new CustomEvent<RapidStorEvent>('rapidstor', { detail: event }),
    );
    document.dispatchEvent(
        new CustomEvent<RapidStorEvent>(`rapidstor.${event.type}`, {
            detail: event,
        }),
    );
    Logger.info(`[dispatchEvent] dispatchEvent with type "${event.type}"`);

    // Legacy callback-based listener
    if (window.rapidstor_api_tracking_listener) {
        try {
            const payload = 'context' in event ? event.context : undefined;
            window.rapidstor_api_tracking_listener(event.type, payload);
        } catch (e) {
            Logger.warn(
                `[dispatchEvent] dispatchEvent with type "${
                    event.type
                }" failed with: ${JSON.stringify(e)}`,
            );
        }
    }
};

export const reservationEvent = (payload: ReservationEventPayloadStandard) => {
    const event: ReservationEvent = { type: 'reservation', context: payload };
    dispatchEvent(event);
};

export const reservationViaMoveInEvent = (
    payload: ReservationEventPayloadStandard,
) => {
    const event: ReservationViaMoveInEvent = {
        type: 'reservation-via-move-in',
        context: payload,
    };
    dispatchEvent(event);
};

export const unitListingLoadedEvent = () => {
    const event: LoadedEvent = { type: 'unit-listing-loaded' };
    dispatchEvent(event);
};

export const showPricesEvent = (payload: ShowPricesPayload) => {
    const event: ShowPricesEvent = { type: 'show-prices', context: payload };
    dispatchEvent(event);
};

export const reservationWithFeeEvent = (
    payload: ReservationEventPayloadStandard,
) => {
    const event: ReservationWithFeeEvent = {
        type: 'reservation-with-fee',
        context: payload,
    };
    dispatchEvent(event);
};

export const saveQuoteEvent = (payload: ReservationEventPayloadStandard) => {
    const event: SaveQuoteEvent = { type: 'save-quote', context: payload };
    dispatchEvent(event);
};

export const scrollEvent = (action?: ScrollAction) => {
    const event: ScrollEvent = action
        ? { type: 'rapidstor-scroll', context: { action } }
        : { type: 'rapidstor-scroll' };
    dispatchEvent(event);
};

export const moveInEvent = (payload: MoveInPayload) => {
    const event: MoveInEvent = { type: 'move-in', context: payload };
    dispatchEvent(event);
};
